import $ from 'jquery'
import cartItemTemplate from 'templates/navigation/hybris-item.pug'
import errorsTemplate from 'templates/feedback-errors.pug'

import debounce from 'garden/src/js/utils/debounce'
import emitter from 'garden/src/js/utils/emitter'

import BaseComponent from 'scripts/components/base-component'
import { maskText } from 'scripts/utils/mask-text'

const DEFAULTS = {
  timing: 3000
}

class AssistedSaleDropdown extends BaseComponent {
  static componentName = 'assisted-sale-dropdown'

  constructor (element, options = {}) {
    super(element)

    this.options = $.extend({}, DEFAULTS, options)
  }

  init () {
    this.$dropdown = this.$element.find('[data-action="dropdown"]')

    this.bindListeners()
  }

  bindListeners () {
    this.$element.on(
      'click',
      debounce(this.onElementClick.bind(this), this.options.timing)
    )
  }

  onElementClick (e) {
    const checkDropdownState = this.$dropdown.hasClass('dropdown-active')

    if (this.carts || !checkDropdownState) {
      return
    }

    this.onGetCarts()
      .done(this.onGetCartsDone.bind(this))
      .fail(this.onGetCartsFail.bind(this))
  }

  onGetCarts () {
    return $.get('/hybris/carts')
  }

  onGetCartsDone (response) {
    this.carts = response.carts

    this.renderCarts(this.carts)
  }

  onGetCartsFail (response) {
    this.$dropdown.removeClass('dropdown-active')

    emitter.emit('stickyFeedback:error', {
      title: 'Ops! Ocorreram os seguintes erros:',
      content: errorsTemplate({ errors: response.responseJSON.errors })
    })
  }

  renderCarts (carts) {
    const cartsWrapper = this.$element.find('[data-cart-list]')

    this.removeSpinner()

    cartsWrapper.html(cartItemTemplate({ carts }))

    this.setMaskElements()
  }

  removeSpinner () {
    this.$element.find('[data-spinner]').remove()
  }

  setMaskElements () {
    this.$maskedFields = this.$element.find('[data-mask-text]')

    maskText(this.$maskedFields)
  }
}

export default ($el) => new AssistedSaleDropdown($el).init()

export { AssistedSaleDropdown as Component }
